import { render, staticRenderFns } from "./PageSharer.vue?vue&type=template&id=a830a06c&scoped=true"
import script from "./PageSharer.vue?vue&type=script&lang=js"
export * from "./PageSharer.vue?vue&type=script&lang=js"
import style0 from "./PageSharer.vue?vue&type=style&index=0&id=a830a06c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a830a06c",
  null
  
)

export default component.exports